module.exports = __webpack_public_path__ + "static/media/CTKM_bagdecor.24db3f26.png";